import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-54e96930"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fase-wrapper" };
const _hoisted_2 = { class: "phase-header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "phase-header-left" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "phase-badge" }, "Fase 2"),
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "phase-title" }, "Recepción de Mercancía Física"),
        /*#__PURE__*/ _createElementVNode("p", { class: "phase-desc" }, "Seleccione una orden emitida, contraste con lo que llegó y ajuste las cantidades recibidas.")
    ])
], -1 /* HOISTED */));
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "panel-section" };
const _hoisted_7 = { class: "section-icon-title" };
const _hoisted_8 = { class: "section-icon" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Seleccionar Orden en Espera", -1 /* HOISTED */));
const _hoisted_10 = {
    key: 0,
    class: "empty-state-sm"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("No hay órdenes en espera. Ve a "),
    /*#__PURE__*/ _createElementVNode("strong", null, "Fase 1"),
    /*#__PURE__*/ _createTextVNode(" para crear una.")
], -1 /* HOISTED */));
const _hoisted_12 = {
    key: 1,
    class: "table-scroll"
};
const _hoisted_13 = { class: "data-table" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Código Orden"),
        /*#__PURE__*/ _createElementVNode("th", null, "Proveedor"),
        /*#__PURE__*/ _createElementVNode("th", null, "Fecha Emisión"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_15 = { class: "code-badge primary" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = {
    key: 1,
    class: "text-muted italic"
};
const _hoisted_18 = { class: "text-muted" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "status-badge warning" };
const _hoisted_21 = { class: "text-end" };
const _hoisted_22 = { style: { "display": "flex", "gap": "8px", "justify-content": "flex-end" } };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
    key: 1,
    class: "reception-grid"
};
const _hoisted_26 = { class: "config-col" };
const _hoisted_27 = { class: "panel-section" };
const _hoisted_28 = { class: "section-icon-title" };
const _hoisted_29 = { class: "section-icon amber" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", { class: "section-title" }, "Cabecera del Ingreso", -1 /* HOISTED */));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "alert-pill" }, "PRECIOS SIN IVA", -1 /* HOISTED */));
const _hoisted_32 = { class: "form-field" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "1. Proveedor (RIF o Nombre)", -1 /* HOISTED */));
const _hoisted_34 = {
    key: 0,
    class: "autocomplete-dropdown",
    style: { "position": "absolute", "top": "calc(100% + 4px)", "left": "0", "width": "100%", "z-index": "50", "max-height": "250px", "overflow-y": "auto", "background": "white", "border": "1px solid #cbd5e1", "border-radius": "8px", "box-shadow": "0 4px 12px rgba(0,0,0,0.1)" }
};
const _hoisted_35 = ["onMousedown"];
const _hoisted_36 = {
    class: "text-muted",
    style: { "display": "block", "font-size": "0.75rem", "font-family": "monospace" }
};
const _hoisted_37 = { style: { "color": "#1e293b", "font-size": "0.9rem" } };
const _hoisted_38 = {
    key: 0,
    class: "dropdown-item text-muted",
    style: { "padding": "12px", "text-align": "center" }
};
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", null, "Sin resultados", -1 /* HOISTED */));
const _hoisted_40 = [
    _hoisted_39
];
const _hoisted_41 = { class: "form-field" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Vía de Ingreso", -1 /* HOISTED */));
const _hoisted_43 = /*#__PURE__*/ _createStaticVNode("<option value=\"Factura\" data-v-54e96930>Número de Factura</option><option value=\"NotaEntrega\" data-v-54e96930>Nota de Entrega</option><option value=\"NotaDespacho\" data-v-54e96930>Nota de Despacho</option><option value=\"NotaPedido\" data-v-54e96930>Nota de Pedido</option><option value=\"OrdenEntrega\" data-v-54e96930>Orden de Entrega</option>", 5);
const _hoisted_48 = [
    _hoisted_43
];
const _hoisted_49 = { class: "form-field" };
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número de Documento", -1 /* HOISTED */));
const _hoisted_51 = { class: "form-field" };
const _hoisted_52 = { style: { "display": "flex", "align-items": "center", "gap": "4px" } };
const _hoisted_53 = {
    for: "factura-upload",
    class: "file-upload-label"
};
const _hoisted_54 = {
    key: 0,
    class: "upload-placeholder"
};
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Seleccionar archivos...", -1 /* HOISTED */));
const _hoisted_56 = {
    key: 1,
    class: "upload-files-list"
};
const _hoisted_57 = ["onClick"];
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("small", { class: "text-muted italic" }, "PDF o Imágenes. Máx 5 archivos.", -1 /* HOISTED */));
const _hoisted_59 = { class: "form-row" };
const _hoisted_60 = { class: "form-field" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "F. Facturac.", -1 /* HOISTED */));
const _hoisted_62 = { class: "form-field" };
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "F. Recepci.", -1 /* HOISTED */));
const _hoisted_64 = { class: "form-field" };
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Condición de Pago", -1 /* HOISTED */));
const _hoisted_66 = { class: "radio-group" };
const _hoisted_67 = {
    key: 0,
    class: "credit-box"
};
const _hoisted_68 = { class: "form-field" };
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Días de Crédito", -1 /* HOISTED */));
const _hoisted_70 = { class: "vencimiento-pill" };
const _hoisted_71 = { class: "form-field" };
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Moneda de Compra", -1 /* HOISTED */));
const _hoisted_73 = ["value"];
const _hoisted_74 = { class: "matrix-col" };
const _hoisted_75 = { class: "panel-section" };
const _hoisted_76 = {
    class: "section-icon-title mb-3",
    style: { "display": "flex", "align-items": "center", "gap": "10px", "width": "100%", "flex-wrap": "wrap" }
};
const _hoisted_77 = { class: "section-icon green" };
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", {
    class: "section-title",
    style: { "flex-shrink": "0" }
}, "Matriz de Recepción Detallada", -1 /* HOISTED */));
const _hoisted_79 = {
    class: "header-actions-wrap",
    style: { "flex": "1", "display": "flex", "justify-content": "flex-end", "gap": "8px", "flex-wrap": "wrap" }
};
const _hoisted_80 = {
    class: "table-scroll",
    style: { "max-height": "460px" }
};
const _hoisted_81 = { class: "data-table" };
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Producto Físico"),
        /*#__PURE__*/ _createElementVNode("th", null, "Referencia"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Cant. Rec."),
        /*#__PURE__*/ _createElementVNode("th", null, "Precio Base"),
        /*#__PURE__*/ _createElementVNode("th", null, "% Dto 1"),
        /*#__PURE__*/ _createElementVNode("th", null, "% Dto 2"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Total Ítem"),
        /*#__PURE__*/ _createElementVNode("th", null, "Vincular Repuesto Interno (Opcional)"),
        /*#__PURE__*/ _createElementVNode("th")
    ])
], -1 /* HOISTED */));
const _hoisted_83 = { class: "font-sm" };
const _hoisted_84 = ["onUpdate:modelValue"];
const _hoisted_85 = ["onUpdate:modelValue"];
const _hoisted_86 = ["onUpdate:modelValue"];
const _hoisted_87 = ["onUpdate:modelValue"];
const _hoisted_88 = ["onUpdate:modelValue"];
const _hoisted_89 = ["onUpdate:modelValue"];
const _hoisted_90 = { class: "text-end font-bold" };
const _hoisted_91 = { class: "autocomplete-cell" };
const _hoisted_92 = ["onUpdate:modelValue", "onInput", "onFocus"];
const _hoisted_93 = {
    key: 0,
    class: "autocomplete-dropdown"
};
const _hoisted_94 = ["onMousedown"];
const _hoisted_95 = { class: "ref-badge sm" };
const _hoisted_96 = ["onClick"];
const _hoisted_97 = { class: "total-footer" };
const _hoisted_98 = { class: "total-note" };
const _hoisted_99 = { class: "total-box" };
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "total-label" }, "Total Recepción", -1 /* HOISTED */));
const _hoisted_101 = { class: "total-value" };
const _hoisted_102 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_103 = { class: "modal-header" };
const _hoisted_104 = { class: "modal-title-group" };
const _hoisted_105 = { class: "icon-bg" };
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "modal-title" }, "Nuevo Repuesto Express", -1 /* HOISTED */));
const _hoisted_107 = {
    class: "export-info-card",
    style: { "margin-bottom": "24px" }
};
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Ingrese la información básica para catalogar el nuevo repuesto sin salir de la compra.", -1 /* HOISTED */));
const _hoisted_109 = {
    class: "creation-mode-toggle",
    style: { "margin-bottom": "20px", "display": "flex", "gap": "10px", "background": "#f1f5f9", "padding": "4px", "border-radius": "8px" }
};
const _hoisted_110 = { style: { "display": "flex", "flex-direction": "column" } };
const _hoisted_111 = {
    class: "form-group premium-input",
    style: { "margin-bottom": "20px" }
};
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label-express" }, "Departamento", -1 /* HOISTED */));
const _hoisted_113 = { class: "input-with-icon autocomplete-express" };
const _hoisted_114 = ["required"];
const _hoisted_115 = {
    key: 0,
    class: "autocomplete-list-express"
};
const _hoisted_116 = ["onMousedown", "innerHTML"];
const _hoisted_117 = {
    class: "form-group premium-input",
    style: { "margin-bottom": "0" }
};
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label-express" }, "Categoría", -1 /* HOISTED */));
const _hoisted_119 = { class: "input-with-icon autocomplete-express" };
const _hoisted_120 = ["disabled", "required"];
const _hoisted_121 = {
    key: 0,
    class: "autocomplete-list-express"
};
const _hoisted_122 = ["onMousedown", "innerHTML"];
const _hoisted_123 = {
    key: 0,
    class: "form-group premium-input",
    style: { "order": "1" }
};
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label-express" }, "Nombre del Repuesto", -1 /* HOISTED */));
const _hoisted_125 = { class: "input-with-icon" };
const _hoisted_126 = ["required"];
const _hoisted_127 = {
    key: 1,
    style: { "order": "2" }
};
const _hoisted_128 = { key: 0 };
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label-express" }, "Nombres de los Repuestos", -1 /* HOISTED */));
const _hoisted_130 = { style: { "max-height": "250px", "overflow-y": "auto", "padding-right": "10px", "margin-bottom": "10px" } };
const _hoisted_131 = {
    class: "input-with-icon",
    style: { "flex": "1" }
};
const _hoisted_132 = ["onUpdate:modelValue", "required"];
const _hoisted_133 = ["onClick"];
const _hoisted_134 = {
    key: 1,
    class: "export-info-card",
    style: { "background": "#fffbeb", "border-color": "#fde68a" }
};
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { style: { "color": "#92400e" } }, "Selecciona primero el Departamento y la Categoría.", -1 /* HOISTED */));
const _hoisted_136 = { class: "modal-footer-express" };
const _hoisted_137 = ["disabled"];
const _hoisted_138 = ["disabled"];
import { ref, computed, onMounted, watch } from 'vue';
import { ComprasService } from '../../../services/ComprasService';
import { RepuestoService } from '../../../services/RepuestoService';
import { InstrumentoPagoService } from '../../../services/InstrumentoPagoService';
import Swal from 'sweetalert2';
import { SaveIcon, SearchIcon, AlertCircleIcon, PointerIcon, FolderOpenIcon, BriefcaseIcon, CalendarIcon, RefreshCwIcon, PackageIcon, CheckIcon, MessageSquareIcon, PlusCircleIcon, FileTextIcon, TrashIcon, DownloadIcon, PlusIcon, XIcon, InfoIcon, LayersIcon, GridIcon, TagIcon, Loader2Icon } from 'lucide-vue-next';
import { DepartamentoService } from '../../../services/DepartamentoService';
import { CategoriaService } from '../../../services/CategoriaService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Fase2Recepcion',
    setup(__props) {
        const ordenes = ref([]);
        const proveedores = ref([]);
        const monedas = ref([]);
        const allRepuestos = ref([]);
        const selectedOrden = ref(null);
        const detalles = ref([]);
        const facturaFiles = ref([]);
        const isProcessing = ref(false);
        const handleFileUpload = (e) => {
            const files = Array.from(e.target.files);
            if (facturaFiles.value.length + files.length > 5) {
                Swal.fire({ icon: 'warning', text: 'Solo se permiten hasta 5 archivos.' });
                return;
            }
            facturaFiles.value = [...facturaFiles.value, ...files];
        };
        const removeFile = (index) => {
            facturaFiles.value.splice(index, 1);
        };
        const agregarFila = () => {
            detalles.value.push({
                nombreProveedor: '',
                referenciaProveedor: '',
                cantidadRecibida: 1,
                cantidadEsperada: 0,
                repuestoBusqueda: '',
                repuestoId: null,
                repuestoAprobadoId: null,
                precioBaseFactura: 0,
                descuento1Porcentaje: 0,
                descuento2Porcentaje: 0,
                showList: false,
                filteredRepuestos: []
            });
        };
        const proveedorSearch = ref('');
        const showProveedorList = ref(false);
        const form = ref({
            proveedorId: null,
            tipoDocumento: 'Factura',
            numeroDocumento: '',
            fechaFacturacion: new Date().toISOString().split('T')[0],
            fechaRecepcion: new Date().toISOString().split('T')[0],
            condicionPago: 'contado',
            diasCredito: 0,
            fechaVencimiento: new Date().toISOString().split('T')[0],
            monedaId: 1
        });
        watch(() => [form.value.condicionPago, form.value.fechaRecepcion, form.value.diasCredito], () => {
            updateVencimiento();
        }, { deep: true });
        onMounted(() => {
            loadOrdenes();
            loadAllRepuestos();
            loadProveedores();
            loadMonedas();
        });
        const loadMonedas = async () => {
            try {
                const res = await InstrumentoPagoService.getMonedas();
                monedas.value = res.datos || [];
                if (monedas.value.length > 0 && !form.value.monedaId) {
                    form.value.monedaId = monedas.value[0].monedaId;
                }
            }
            catch (e) {
                console.error("Error al cargar monedas", e);
            }
        };
        const loadProveedores = async () => {
            try {
                const { ProveedorService } = await import('../../../services/ProveedorService');
                const res = await ProveedorService.getAll(1, '', '');
                // Manejar si viene en datos.items o directamente en datos
                if (res.datos?.items) {
                    proveedores.value = res.datos.items;
                }
                else if (Array.isArray(res.datos)) {
                    proveedores.value = res.datos;
                }
                else {
                    proveedores.value = [];
                }
            }
            catch (e) {
                console.error("Error al cargar proveedores", e);
                proveedores.value = [];
            }
        };
        const filteredProveedores = computed(() => {
            const q = proveedorSearch.value.toLowerCase().trim();
            if (!Array.isArray(proveedores.value))
                return [];
            if (!q)
                return proveedores.value.slice(0, 50);
            return proveedores.value.filter(p => (p.nombreRazonSocial || '').toLowerCase().includes(q) ||
                (p.documentoNumero || '').toLowerCase().includes(q)).slice(0, 50);
        });
        const selectProveedor = (prov) => {
            form.value.proveedorId = prov.proveedorId;
            proveedorSearch.value = prov.nombreRazonSocial;
            showProveedorList.value = false;
        };
        const hideProveedorList = () => {
            setTimeout(() => {
                showProveedorList.value = false;
            }, 200);
        };
        // Auto-limpiar ID si el usuario borra o cambia el texto manualmente y realizar búsqueda en vivo
        let searchTimeout = null;
        watch(proveedorSearch, (newVal) => {
            // Limpiar timeout previo para debouncing
            if (searchTimeout)
                clearTimeout(searchTimeout);
            if (!newVal || newVal.trim() === '') {
                form.value.proveedorId = null;
                loadProveedores(); // Recargar iniciales
            }
            else {
                // Si escribió algo distinto al nombre seleccionado, se rompe el vínculo
                const provActual = proveedores.value.find((p) => p.proveedorId === form.value.proveedorId);
                if (provActual && provActual.nombreRazonSocial !== newVal) {
                    form.value.proveedorId = null;
                }
                // Búsqueda en vivo (debounced)
                searchTimeout = setTimeout(async () => {
                    const q = newVal.trim();
                    if (q.length >= 2) {
                        try {
                            const { ProveedorService } = await import('../../../services/ProveedorService');
                            const res = await ProveedorService.getAll(1, q, '');
                            const items = res.datos?.items || (Array.isArray(res.datos) ? res.datos : []);
                            proveedores.value = items;
                        }
                        catch (e) {
                            console.error("Error en búsqueda en vivo de proveedores", e);
                        }
                    }
                }, 400);
            }
        });
        const loadAllRepuestos = async () => {
            try {
                allRepuestos.value = await RepuestoService.getLookup();
            }
            catch (e) {
                console.error("Error al cargar lookup de repuestos", e);
            }
        };
        const crearRepuestoExpress = () => {
            isModalRepuestoOpen.value = true;
        };
        // --- MODAL REPUESTO EXPRESS STATE ---
        const isModalRepuestoOpen = ref(false);
        const isSavingRepuesto = ref(false);
        const creationMode = ref('individual');
        const bulkNombresList = ref(['']);
        const currentRepuestoForm = ref({ nombre: '', departamentoID: 0, categoriaID: 0, active: true });
        const searchDepartamento = ref('');
        const showDepartamentos = ref(false);
        const searchCategoria = ref('');
        const showCategorias = ref(false);
        const departamentosList = ref([]);
        const todasCategoriasList = ref([]);
        const categoriasFiltradasList = ref([]);
        const loadModalMaestros = async () => {
            try {
                const [deps, cats] = await Promise.all([
                    DepartamentoService.getAll(),
                    CategoriaService.getAll()
                ]);
                departamentosList.value = deps;
                todasCategoriasList.value = cats;
            }
            catch (e) {
                console.error("Error al cargar maestros para el modal", e);
            }
        };
        onMounted(() => {
            loadModalMaestros();
        });
        const filteredDepartamentosList = computed(() => {
            let deps = departamentosList.value;
            if (searchDepartamento.value) {
                const q = searchDepartamento.value.toLowerCase();
                deps = deps.filter(d => d.nombre.toLowerCase().includes(q));
            }
            return deps.map(d => {
                if (!searchDepartamento.value)
                    return { ...d, highlightedNombre: d.nombre };
                const regex = new RegExp(`(${searchDepartamento.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                return { ...d, highlightedNombre: d.nombre.replace(regex, `<mark>$1</mark>`) };
            });
        });
        const filteredCategoriasList = computed(() => {
            let cats = categoriasFiltradasList.value;
            if (searchCategoria.value) {
                const q = searchCategoria.value.toLowerCase();
                cats = cats.filter(c => c.nombre.toLowerCase().includes(q));
            }
            return cats.map(c => {
                if (!searchCategoria.value)
                    return { ...c, highlightedNombre: c.nombre };
                const regex = new RegExp(`(${searchCategoria.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                return { ...c, highlightedNombre: c.nombre.replace(regex, `<mark>$1</mark>`) };
            });
        });
        const selectDepartamento = (dep) => {
            currentRepuestoForm.value.departamentoID = dep.departamentoID;
            searchDepartamento.value = dep.nombre;
            showDepartamentos.value = false;
            currentRepuestoForm.value.categoriaID = 0;
            searchCategoria.value = '';
            categoriasFiltradasList.value = todasCategoriasList.value.filter(c => c.departamentoID === dep.departamentoID && c.estado !== false);
        };
        const selectCategoria = (cat) => {
            currentRepuestoForm.value.categoriaID = cat.categoriaID;
            searchCategoria.value = cat.nombre;
            showCategorias.value = false;
        };
        const onBlurDepartamento = () => setTimeout(() => showDepartamentos.value = false, 200);
        const onBlurCategoria = () => setTimeout(() => showCategorias.value = false, 200);
        const addBulkInput = () => bulkNombresList.value.push('');
        const removeBulkInput = (index) => bulkNombresList.value.splice(index, 1);
        const closeRepuestoModal = () => {
            isModalRepuestoOpen.value = false;
            currentRepuestoForm.value = { nombre: '', departamentoID: 0, categoriaID: 0, active: true };
            searchDepartamento.value = '';
            searchCategoria.value = '';
            bulkNombresList.value = [''];
        };
        const saveRepuesto = async () => {
            isSavingRepuesto.value = true;
            try {
                if (creationMode.value === 'individual') {
                    await RepuestoService.addRepuesto(currentRepuestoForm.value);
                }
                else {
                    await RepuestoService.addRepuestoBulk({
                        departamentoID: currentRepuestoForm.value.departamentoID,
                        categoriaID: currentRepuestoForm.value.categoriaID,
                        nombres: bulkNombresList.value.filter(n => n.trim() !== '')
                    });
                }
                await loadAllRepuestos();
                closeRepuestoModal();
                Swal.fire({ icon: 'success', title: 'Creado', text: 'Repuesto(s) añadidos correctamente.', timer: 2000, showConfirmButton: false });
            }
            catch (e) {
                Swal.fire("Error", e.message || "No se pudo crear", "error");
            }
            finally {
                isSavingRepuesto.value = false;
            }
        };
        const updateVencimiento = () => {
            if (form.value.condicionPago !== 'credito') {
                form.value.fechaVencimiento = form.value.fechaRecepcion;
                return;
            }
            const d = new Date(form.value.fechaRecepcion);
            d.setDate(d.getDate() + (form.value.diasCredito || 0));
            form.value.fechaVencimiento = d.toISOString().split('T')[0];
        };
        const loadOrdenes = async () => {
            try {
                const res = await ComprasService.getOrdenes();
                ordenes.value = (res || []).filter((o) => o.estadoCompraId === 1);
            }
            catch (error) {
                console.error(error);
            }
        };
        const formatFecha = (fecha) => {
            if (!fecha)
                return '';
            return new Date(fecha).toLocaleDateString();
        };
        const seleccionarOrden = async (orden) => {
            try {
                const fullOrden = await ComprasService.getOrdenById(orden.ordenPedidoProveedorId);
                selectedOrden.value = fullOrden;
                // La matriz arranca limpia para que el operario ingrese manualmente la mercancía recibida
                detalles.value = [];
                updateVencimiento();
            }
            catch (error) {
                Swal.fire({ icon: 'error', text: 'Error al cargar los detalles de la orden' });
            }
        };
        const downloadOrderAsCsv = async (orden) => {
            try {
                let dataToExport = [];
                if (orden.detalles && orden.detalles.length > 0) {
                    dataToExport = orden.detalles;
                }
                else {
                    const res = await ComprasService.getOrdenById(orden.ordenPedidoProveedorId);
                    dataToExport = res.detalles || [];
                }
                if (dataToExport.length === 0) {
                    Swal.fire({ icon: 'info', text: 'Esta orden no tiene ítems registrados.' });
                    return;
                }
                // Formato espejo del Excel de la imagen
                let csvContent = "CÓDIGO;PROVEEDOR;DESCRIPCIÓN;REFERENCIA;PEDIDO;PRECIO LISTA;DESCUENTO;COSTO DEFINITIVO;TOTAL COSTO PEDIDO\n";
                dataToExport.forEach((d) => {
                    const cant = d.pedido || 0;
                    const precioF = d.costoDefinitivo || 0;
                    const total = cant * precioF;
                    const row = [
                        d.codigo || '',
                        d.proveedor || '',
                        d.descripcion || '',
                        d.referencia || '',
                        cant,
                        (d.precioLista || 0).toString().replace('.', ','),
                        (d.descuento || 0).toString().replace('.', ','),
                        (precioF || 0).toString().replace('.', ','),
                        total.toFixed(2).replace('.', ',')
                    ];
                    csvContent += row.join(';') + "\n";
                });
                const blob = new Blob(["\ufeff", csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Orden_${orden.codigoOrden || 'Surtimotos'}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            catch (e) {
                console.error(e);
                Swal.fire({ icon: 'error', text: 'No se pudo generar el archivo CSV' });
            }
        };
        const searchRepuestosInRow = (item) => {
            const q = item.repuestoBusqueda.toLowerCase().trim();
            if (!q) {
                item.filteredRepuestos = [];
                return;
            }
            item.filteredRepuestos = allRepuestos.value.filter((r) => (r.nombre || '').toLowerCase().includes(q) || (r.referencia || '').toLowerCase().includes(q) || (r.codigoEquivalente || '').toLowerCase().includes(q)).slice(0, 10);
        };
        const selectRepuestoForRow = (item, r) => {
            item.repuestoAprobadoId = r.repuestoId;
            item.repuestoBusqueda = `${r.codigoEquivalente || r.referencia || ''} - ${r.nombre}`;
            item.showList = false;
        };
        const calcularSubtotal = (item) => {
            const precio = parseFloat(item.precioBaseFactura) || 0;
            const cant = parseFloat((item.cantidadRecibida ?? item.cantidad)) || 0;
            let sub = precio * cant;
            const dto1 = parseFloat(item.descuento1Porcentaje) || 0;
            const dto2 = parseFloat(item.descuento2Porcentaje) || 0;
            if (dto1 > 0)
                sub = sub * (1 - (dto1 / 100));
            if (dto2 > 0)
                sub = sub * (1 - (dto2 / 100));
            return sub;
        };
        const totalGeneral = computed(() => {
            return detalles.value.reduce((acc, curr) => acc + calcularSubtotal(curr), 0);
        });
        const getRowClass = (item) => {
            if (item.cantidadRecibida !== item.cantidadEsperada)
                return 'table-warning';
            if (item.repuestoAprobadoId)
                return 'table-success';
            return '';
        };
        const isValid = computed(() => {
            if (!form.value.proveedorId)
                return false;
            if (!form.value.numeroDocumento)
                return false;
            if (facturaFiles.value.length === 0)
                return false; // Factura obligatoria
            if (detalles.value.length === 0)
                return false;
            // OJO: Si el negocio dice que vincular repuesto es opcional, ya no podemos bloquear si !d.repuestoAprobadoId
            // Pero sí debemos validar que no hayan lineas en blanco de cantidad
            const incompletos = detalles.value.filter(d => d.cantidadRecibida <= 0 || !d.nombreProveedor);
            return incompletos.length === 0;
        });
        const saveIngresoFisico = async () => {
            if (!isValid.value || isProcessing.value)
                return;
            isProcessing.value = true;
            const formData = new FormData();
            // Agregar archivos
            facturaFiles.value.forEach(file => {
                formData.append('Facturas', file);
            });
            // Estructura de detalles para el JSON
            const validDetalles = detalles.value
                .filter(d => d.cantidadRecibida > 0)
                .map(d => ({
                repuestoId: d.repuestoAprobadoId || null,
                nombreProductoProveedor: d.nombreProveedor || '',
                referenciaProductoProveedor: d.referenciaProveedor || '',
                cantidad: d.cantidadRecibida,
                precioBaseFactura: d.precioBaseFactura || 0,
                descuento1Porcentaje: d.descuento1Porcentaje || 0,
                descuento2Porcentaje: d.descuento2Porcentaje || 0,
                lote: "LOTE-AUTOGENERADO",
                ubicacionA: "Almacen Principal",
                ubicacionB: "",
                ubicacionC: ""
            }));
            // Agregar campos base al FormData
            formData.append('tipoDocumento', form.value.tipoDocumento);
            formData.append('numeroDocumento', form.value.numeroDocumento);
            formData.append('fechaFacturacion', form.value.fechaFacturacion);
            formData.append('fechaRecepcion', form.value.fechaRecepcion);
            formData.append('fechaVencimiento', form.value.fechaVencimiento);
            formData.append('diasCredito', form.value.diasCredito.toString());
            formData.append('esCredito', (form.value.condicionPago === 'credito').toString());
            formData.append('esPrepago', (form.value.condicionPago === 'prepago').toString());
            formData.append('proveedorId', form.value.proveedorId.toString());
            formData.append('monedaId', form.value.monedaId.toString());
            formData.append('ordenPedidoProveedorId', selectedOrden.value.ordenPedidoProveedorId.toString());
            // Enviar detalles como JSON stringified (el backend lo parseará si se configura, o podemos enviarlos uno a uno)
            // Pero el backend espera IngresoCompraCreateDto que tiene una lista de detalles.
            // Con [FromForm], podemos enviar objetos complejos usando la notación Detalles[0].Propiedad
            validDetalles.forEach((d, idx) => {
                formData.append(`detalles[${idx}].repuestoId`, (d.repuestoId || '').toString());
                formData.append(`detalles[${idx}].nombreProductoProveedor`, d.nombreProductoProveedor);
                formData.append(`detalles[${idx}].referenciaProductoProveedor`, d.referenciaProductoProveedor);
                formData.append(`detalles[${idx}].cantidad`, d.cantidad.toString());
                formData.append(`detalles[${idx}].precioBaseFactura`, d.precioBaseFactura.toString());
                formData.append(`detalles[${idx}].descuento1Porcentaje`, d.descuento1Porcentaje.toString());
                formData.append(`detalles[${idx}].descuento2Porcentaje`, d.descuento2Porcentaje.toString());
                formData.append(`detalles[${idx}].lote`, d.lote);
                formData.append(`detalles[${idx}].ubicacionA`, d.ubicacionA);
            });
            try {
                await ComprasService.createIngreso(formData);
                Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Recepción Completada', text: 'Existencias ingresadas. Listo para Auditoría.', timer: 4000, showConfirmButton: false, timerProgressBar: true });
                selectedOrden.value = null;
                facturaFiles.value = []; // Limpiar archivos
                loadOrdenes();
            }
            catch (error) {
                Swal.fire({ icon: 'error', title: 'Error', text: error.message || "Error al procesar recepción física" });
            }
            finally {
                isProcessing.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" ── Phase Header ── "),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (selectedOrden.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-primary-action",
                            onClick: saveIngresoFisico,
                            disabled: !isValid.value || isProcessing.value
                        }, [
                            (isProcessing.value)
                                ? (_openBlock(), _createBlock(_unref(Loader2Icon), {
                                    key: 0,
                                    class: "spin",
                                    size: 16
                                }))
                                : (_openBlock(), _createBlock(_unref(SaveIcon), {
                                    key: 1,
                                    size: 16
                                })),
                            _createTextVNode(" " + _toDisplayString(isProcessing.value ? 'Procesando...' : 'Procesar Recepción'), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_4))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ── Selección de Orden ── "),
                (!selectedOrden.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_unref(SearchIcon), { size: 18 })
                                ]),
                                _hoisted_9
                            ]),
                            (ordenes.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createVNode(_unref(AlertCircleIcon), {
                                        size: 18,
                                        class: "text-warning"
                                    }),
                                    _hoisted_11
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("table", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ordenes.value, (ord) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: ord.ordenPedidoProveedorId
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_15, _toDisplayString(ord.codigoOrden), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        (ord.proveedor)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(ord.proveedor.nombreRazonSocial), 1 /* TEXT */))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_17, "Por definir en esta fase"))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_18, _toDisplayString(formatFecha(ord.fechaEmision)), 1 /* TEXT */),
                                                    _createElementVNode("td", _hoisted_19, [
                                                        _createElementVNode("span", _hoisted_20, _toDisplayString(ord.nombreEstado), 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_21, [
                                                        _createElementVNode("div", _hoisted_22, [
                                                            _createElementVNode("button", {
                                                                class: "btn-action-sm",
                                                                style: { "background": "#f0fdf4", "color": "#16a34a", "border-color": "#bbf7d0" },
                                                                onClick: _withModifiers(($event) => (downloadOrderAsCsv(ord)), ["stop"]),
                                                                title: "Descargar CSV"
                                                            }, [
                                                                _createVNode(_unref(DownloadIcon), { size: 14 }),
                                                                _createTextVNode(" CSV ")
                                                            ], 8 /* PROPS */, _hoisted_23),
                                                            _createElementVNode("button", {
                                                                class: "btn-action-sm",
                                                                onClick: ($event) => (seleccionarOrden(ord))
                                                            }, [
                                                                _createVNode(_unref(PointerIcon), { size: 14 }),
                                                                _createTextVNode(" Seleccionar ")
                                                            ], 8 /* PROPS */, _hoisted_24)
                                                        ])
                                                    ])
                                                ]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]))
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" ── Recepción Detallada ── "),
                (selectedOrden.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createCommentVNode(" LEFT: Cabecera "),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_unref(FolderOpenIcon), { size: 18 })
                                    ]),
                                    _hoisted_30
                                ]),
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["autocomplete-input-wrap", { linked: form.value.proveedorId }]),
                                        style: { "position": "relative" }
                                    }, [
                                        _createVNode(_unref(BriefcaseIcon), { size: 16 }),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "autocomplete-input",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((proveedorSearch).value = $event)),
                                            onFocus: _cache[1] || (_cache[1] = ($event) => (showProveedorList.value = true)),
                                            onInput: _cache[2] || (_cache[2] = ($event) => (showProveedorList.value = true)),
                                            onBlur: hideProveedorList,
                                            placeholder: "Buscar proveedor...",
                                            autocomplete: "off"
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, proveedorSearch.value]
                                        ]),
                                        (showProveedorList.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProveedores.value, (prov) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        type: "button",
                                                        class: "dropdown-prov-item",
                                                        key: prov.proveedorId,
                                                        onMousedown: _withModifiers(($event) => (selectProveedor(prov)), ["prevent"])
                                                    }, [
                                                        _createElementVNode("span", _hoisted_36, _toDisplayString(prov.documentoNumero || prov.rif), 1 /* TEXT */),
                                                        _createElementVNode("strong", _hoisted_37, _toDisplayString(prov.nombreRazonSocial), 1 /* TEXT */)
                                                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_35));
                                                }), 128 /* KEYED_FRAGMENT */)),
                                                (filteredProveedores.value.length === 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.tipoDocumento) = $event)),
                                        class: "form-select-custom"
                                    }, _hoisted_48, 512 /* NEED_PATCH */), [
                                        [_vModelSelect, form.value.tipoDocumento]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                    _hoisted_50,
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.numeroDocumento) = $event)),
                                        class: "form-input",
                                        placeholder: "Ej: FAC-00123"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, form.value.numeroDocumento]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("label", _hoisted_52, [
                                        _createVNode(_unref(FileTextIcon), { size: 14 }),
                                        _createTextVNode(" Adjuntar Factura (Obligatorio) ")
                                    ]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["file-upload-wrapper", { 'has-files': facturaFiles.value.length > 0 }])
                                    }, [
                                        _createElementVNode("input", {
                                            type: "file",
                                            id: "factura-upload",
                                            multiple: "",
                                            onChange: handleFileUpload,
                                            hidden: "",
                                            accept: ".pdf,image/*"
                                        }, null, 32 /* NEED_HYDRATION */),
                                        _createElementVNode("label", _hoisted_53, [
                                            (facturaFiles.value.length === 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                    _createVNode(_unref(PlusCircleIcon), { size: 20 }),
                                                    _hoisted_55
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facturaFiles.value, (f, idx) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: idx,
                                                            class: "file-tag"
                                                        }, [
                                                            _createVNode(_unref(FileTextIcon), { size: 12 }),
                                                            _createElementVNode("span", null, _toDisplayString(f.name), 1 /* TEXT */),
                                                            _createElementVNode("button", {
                                                                onClick: _withModifiers(($event) => (removeFile(idx)), ["prevent", "stop"]),
                                                                class: "btn-remove-file"
                                                            }, [
                                                                _createVNode(_unref(XIcon), { size: 12 })
                                                            ], 8 /* PROPS */, _hoisted_57)
                                                        ]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]))
                                        ])
                                    ], 2 /* CLASS */),
                                    _hoisted_58
                                ]),
                                _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                        _hoisted_61,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "date",
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.fechaFacturacion) = $event)),
                                            class: "form-input"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, form.value.fechaFacturacion]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_62, [
                                        _hoisted_63,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "date",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.value.fechaRecepcion) = $event)),
                                            class: "form-input",
                                            onChange: updateVencimiento
                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                            [_vModelText, form.value.fechaRecepcion]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("label", {
                                            class: _normalizeClass(["radio-option", { active: form.value.condicionPago === 'contado' }])
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.value.condicionPago) = $event)),
                                                value: "contado",
                                                hidden: ""
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelRadio, form.value.condicionPago]
                                            ]),
                                            _createTextVNode(" Contado ")
                                        ], 2 /* CLASS */),
                                        _createElementVNode("label", {
                                            class: _normalizeClass(["radio-option", { active: form.value.condicionPago === 'prepago' }])
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.value.condicionPago) = $event)),
                                                value: "prepago",
                                                hidden: ""
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelRadio, form.value.condicionPago]
                                            ]),
                                            _createTextVNode(" Prepago ")
                                        ], 2 /* CLASS */),
                                        _createElementVNode("label", {
                                            class: _normalizeClass(["radio-option", { active: form.value.condicionPago === 'credito' }])
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.value.condicionPago) = $event)),
                                                value: "credito",
                                                hidden: ""
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelRadio, form.value.condicionPago]
                                            ]),
                                            _createTextVNode(" Crédito ")
                                        ], 2 /* CLASS */)
                                    ]),
                                    (form.value.condicionPago === 'credito')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                            _createElementVNode("div", _hoisted_68, [
                                                _hoisted_69,
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.value.diasCredito) = $event)),
                                                    class: "form-input",
                                                    onInput: updateVencimiento
                                                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [
                                                        _vModelText,
                                                        form.value.diasCredito,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_70, [
                                                _createVNode(_unref(CalendarIcon), { size: 14 }),
                                                _createTextVNode(" Vence: "),
                                                _createElementVNode("strong", null, _toDisplayString(formatFecha(form.value.fechaVencimiento)), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                    _hoisted_72,
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.value.monedaId) = $event)),
                                        class: "form-select-custom"
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monedas.value, (m) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: m.monedaId,
                                                value: m.monedaId
                                            }, _toDisplayString(m.simbolo) + " (" + _toDisplayString(m.nombre) + ") ", 9 /* TEXT, PROPS */, _hoisted_73));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */), [
                                        [_vModelSelect, form.value.monedaId]
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    class: "btn-outline-danger-sm",
                                    onClick: _cache[12] || (_cache[12] = ($event) => (selectedOrden.value = null))
                                }, [
                                    _createVNode(_unref(RefreshCwIcon), { size: 14 }),
                                    _createTextVNode(" Cambiar Orden ")
                                ])
                            ])
                        ]),
                        _createCommentVNode(" RIGHT: Matriz "),
                        _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                                _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                        _createVNode(_unref(PackageIcon), { size: 18 })
                                    ]),
                                    _hoisted_78,
                                    _createElementVNode("div", _hoisted_79, [
                                        (selectedOrden.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[13] || (_cache[13] = ($event) => (downloadOrderAsCsv(selectedOrden.value))),
                                                class: "btn-outline-primary-sm"
                                            }, [
                                                _createVNode(_unref(DownloadIcon), { size: 14 }),
                                                _createTextVNode(" Descargar Original CSV ")
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("button", {
                                            class: "btn-primary-action-sm",
                                            onClick: agregarFila
                                        }, [
                                            _createVNode(_unref(PlusCircleIcon), { size: 14 }),
                                            _createTextVNode(" Añadir Fila ")
                                        ]),
                                        _createElementVNode("button", {
                                            class: "btn-outline-primary-sm",
                                            onClick: crearRepuestoExpress,
                                            style: { "color": "#7c3aed", "border-color": "#c4b5fd", "background": "#f5f3ff" }
                                        }, [
                                            _createVNode(_unref(PlusIcon), { size: 14 }),
                                            _createTextVNode(" Repuesto Express ")
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("table", _hoisted_81, [
                                        _hoisted_82,
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detalles.value, (item, i) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: i,
                                                    class: _normalizeClass(getRowClass(item))
                                                }, [
                                                    _createElementVNode("td", _hoisted_83, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "input-sm font-sm",
                                                            "onUpdate:modelValue": ($event) => ((item.nombreProveedor) = $event),
                                                            placeholder: "Desc. según factura",
                                                            style: { "width": "100%", "border": "1px solid #cbd5e1", "border-radius": "4px", "padding": "4px" }
                                                        }, null, 8 /* PROPS */, _hoisted_84), [
                                                            [_vModelText, item.nombreProveedor]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((item.referenciaProveedor) = $event),
                                                            placeholder: "Ref.",
                                                            style: { "width": "90px", "border": "1px solid #cbd5e1", "border-radius": "4px", "padding": "4px" }
                                                        }, null, 8 /* PROPS */, _hoisted_85), [
                                                            [_vModelText, item.referenciaProveedor]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((item.cantidadRecibida) = $event),
                                                            min: "0"
                                                        }, null, 8 /* PROPS */, _hoisted_86), [
                                                            [
                                                                _vModelText,
                                                                item.cantidadRecibida,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            step: "0.01",
                                                            class: "input-sm text-end",
                                                            "onUpdate:modelValue": ($event) => ((item.precioBaseFactura) = $event)
                                                        }, null, 8 /* PROPS */, _hoisted_87), [
                                                            [
                                                                _vModelText,
                                                                item.precioBaseFactura,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((item.descuento1Porcentaje) = $event)
                                                        }, null, 8 /* PROPS */, _hoisted_88), [
                                                            [
                                                                _vModelText,
                                                                item.descuento1Porcentaje,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "number",
                                                            class: "input-sm text-center",
                                                            "onUpdate:modelValue": ($event) => ((item.descuento2Porcentaje) = $event)
                                                        }, null, 8 /* PROPS */, _hoisted_89), [
                                                            [
                                                                _vModelText,
                                                                item.descuento2Porcentaje,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", _hoisted_90, "$" + _toDisplayString(calcularSubtotal(item).toFixed(2)), 1 /* TEXT */),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", _hoisted_91, [
                                                            _createElementVNode("div", {
                                                                class: _normalizeClass(["autocomplete-input-wrap", { linked: item.repuestoAprobadoId }])
                                                            }, [
                                                                (item.repuestoAprobadoId)
                                                                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                                                        key: 0,
                                                                        size: 14,
                                                                        class: "text-success"
                                                                    }))
                                                                    : (_openBlock(), _createBlock(_unref(SearchIcon), {
                                                                        key: 1,
                                                                        size: 14,
                                                                        class: "text-muted"
                                                                    })),
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "text",
                                                                    class: "autocomplete-input",
                                                                    placeholder: "Buscar Repuesto...",
                                                                    "onUpdate:modelValue": ($event) => ((item.repuestoBusqueda) = $event),
                                                                    onInput: ($event) => (searchRepuestosInRow(item)),
                                                                    onFocus: ($event) => (item.showList = true)
                                                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_92), [
                                                                    [_vModelText, item.repuestoBusqueda]
                                                                ])
                                                            ], 2 /* CLASS */),
                                                            (item.showList && item.filteredRepuestos && item.filteredRepuestos.length > 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filteredRepuestos, (r) => {
                                                                        return (_openBlock(), _createElementBlock("button", {
                                                                            type: "button",
                                                                            class: "dropdown-item",
                                                                            key: r.repuestoId,
                                                                            onMousedown: _withModifiers(($event) => (selectRepuestoForRow(item, r)), ["prevent"])
                                                                        }, [
                                                                            _createElementVNode("span", _hoisted_95, _toDisplayString(r.referencia), 1 /* TEXT */),
                                                                            _createTextVNode(" " + _toDisplayString(r.nombre), 1 /* TEXT */)
                                                                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_94));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("button", {
                                                            class: "btn-action-sm text-danger",
                                                            style: { "background": "#fef2f2", "border": "1px solid #fecaca", "color": "#ef4444" },
                                                            onClick: ($event) => (detalles.value.splice(i, 1))
                                                        }, [
                                                            _createVNode(_unref(TrashIcon), { size: 14 })
                                                        ], 8 /* PROPS */, _hoisted_96)
                                                    ])
                                                ], 2 /* CLASS */));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("p", _hoisted_98, [
                                        _createVNode(_unref(MessageSquareIcon), { size: 14 }),
                                        _createTextVNode(" El total debe coincidir con el bruto de su factura física (Sin IVA). ")
                                    ]),
                                    _createElementVNode("div", _hoisted_99, [
                                        _hoisted_100,
                                        _createElementVNode("span", _hoisted_101, "$" + _toDisplayString(totalGeneral.value.toFixed(2)), 1 /* TEXT */)
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" MODAL REPUESTO EXPRESS (REPLICATED FROM REPUESTOS/INDEX.VUE) "),
                _createVNode(_Transition, { name: "modal-fade" }, {
                    default: _withCtx(() => [
                        (isModalRepuestoOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["modal-window", { 'large-modal': creationMode.value === 'bulk' }])
                                }, [
                                    _createElementVNode("div", _hoisted_103, [
                                        _createElementVNode("div", _hoisted_104, [
                                            _createElementVNode("div", _hoisted_105, [
                                                _createVNode(_unref(PackageIcon), {
                                                    size: 24,
                                                    class: "text-primary-express"
                                                })
                                            ]),
                                            _hoisted_106
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: closeRepuestoModal,
                                            class: "btn-close-modal"
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 24 })
                                        ])
                                    ]),
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(saveRepuesto, ["prevent"]),
                                        class: "modal-body"
                                    }, [
                                        _createElementVNode("div", _hoisted_107, [
                                            _createVNode(_unref(InfoIcon), {
                                                size: 18,
                                                class: "text-primary-express"
                                            }),
                                            _hoisted_108
                                        ]),
                                        _createElementVNode("div", _hoisted_109, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                style: _normalizeStyle([creationMode.value === 'individual' ? 'background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.1); color: #0f172a;' : 'background: transparent; color: #64748b;', { "flex": "1", "padding": "8px", "border": "none", "border-radius": "6px", "font-weight": "600", "cursor": "pointer", "transition": "0.2s" }]),
                                                onClick: _cache[14] || (_cache[14] = ($event) => (creationMode.value = 'individual'))
                                            }, "Individual", 4 /* STYLE */),
                                            _createElementVNode("button", {
                                                type: "button",
                                                style: _normalizeStyle([creationMode.value === 'bulk' ? 'background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,0.1); color: #0f172a;' : 'background: transparent; color: #64748b;', { "flex": "1", "padding": "8px", "border": "none", "border-radius": "6px", "font-weight": "600", "cursor": "pointer", "transition": "0.2s" }]),
                                                onClick: _cache[15] || (_cache[15] = ($event) => (creationMode.value = 'bulk'))
                                            }, "Múltiple", 4 /* STYLE */)
                                        ]),
                                        _createElementVNode("div", _hoisted_110, [
                                            _createElementVNode("div", {
                                                class: "form-grid-express",
                                                style: _normalizeStyle([{ order: creationMode.value === 'bulk' ? 1 : 2 }, { "display": "grid", "grid-template-columns": "1fr 1fr", "gap": "15px", "margin-bottom": "20px", "margin-top": "15px" }])
                                            }, [
                                                _createElementVNode("div", _hoisted_111, [
                                                    _hoisted_112,
                                                    _createElementVNode("div", _hoisted_113, [
                                                        _createVNode(_unref(LayersIcon), {
                                                            size: 18,
                                                            class: "input-icon-express"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((searchDepartamento).value = $event)),
                                                            onFocus: _cache[17] || (_cache[17] = ($event) => (showDepartamentos.value = true)),
                                                            onBlur: onBlurDepartamento,
                                                            class: "form-control-express",
                                                            placeholder: "Buscar...",
                                                            required: currentRepuestoForm.value.departamentoID === 0
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_114), [
                                                            [_vModelText, searchDepartamento.value]
                                                        ]),
                                                        (showDepartamentos.value && filteredDepartamentosList.value.length > 0)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_115, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDepartamentosList.value, (dep) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: dep.departamentoID,
                                                                        onMousedown: _withModifiers(($event) => (selectDepartamento(dep)), ["prevent"]),
                                                                        innerHTML: dep.highlightedNombre
                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_116));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_117, [
                                                    _hoisted_118,
                                                    _createElementVNode("div", _hoisted_119, [
                                                        _createVNode(_unref(GridIcon), {
                                                            size: 18,
                                                            class: "input-icon-express"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((searchCategoria).value = $event)),
                                                            onFocus: _cache[19] || (_cache[19] = ($event) => (showCategorias.value = true)),
                                                            onBlur: onBlurCategoria,
                                                            class: "form-control-express",
                                                            placeholder: "Buscar...",
                                                            disabled: !currentRepuestoForm.value.departamentoID,
                                                            required: currentRepuestoForm.value.categoriaID === 0
                                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_120), [
                                                            [_vModelText, searchCategoria.value]
                                                        ]),
                                                        (showCategorias.value && filteredCategoriasList.value.length > 0)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_121, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCategoriasList.value, (cat) => {
                                                                    return (_openBlock(), _createElementBlock("li", {
                                                                        key: cat.categoriaID,
                                                                        onMousedown: _withModifiers(($event) => (selectCategoria(cat)), ["prevent"]),
                                                                        innerHTML: cat.highlightedNombre
                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_122));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ])
                                            ], 4 /* STYLE */),
                                            (creationMode.value === 'individual')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                    _hoisted_124,
                                                    _createElementVNode("div", _hoisted_125, [
                                                        _createVNode(_unref(TagIcon), {
                                                            size: 18,
                                                            class: "input-icon-express"
                                                        }),
                                                        _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((currentRepuestoForm.value.nombre) = $event)),
                                                            placeholder: "Ej: Amortiguador Delantero",
                                                            required: creationMode.value === 'individual',
                                                            class: "form-control-express"
                                                        }, null, 8 /* PROPS */, _hoisted_126), [
                                                            [_vModelText, currentRepuestoForm.value.nombre]
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            (creationMode.value === 'bulk')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                                    (currentRepuestoForm.value.departamentoID > 0 && currentRepuestoForm.value.categoriaID > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                            _hoisted_129,
                                                            _createElementVNode("div", _hoisted_130, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkNombresList.value, (nombre, index) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: index,
                                                                        style: { "display": "flex", "gap": "10px", "margin-bottom": "10px" }
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_131, [
                                                                            _createVNode(_unref(TagIcon), {
                                                                                size: 18,
                                                                                class: "input-icon-express"
                                                                            }),
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                type: "text",
                                                                                "onUpdate:modelValue": ($event) => ((bulkNombresList.value[index]) = $event),
                                                                                placeholder: "Ej: Repuesto...",
                                                                                required: creationMode.value === 'bulk',
                                                                                class: "form-control-express"
                                                                            }, null, 8 /* PROPS */, _hoisted_132), [
                                                                                [_vModelText, bulkNombresList.value[index]]
                                                                            ])
                                                                        ]),
                                                                        (bulkNombresList.value.length > 1)
                                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                                key: 0,
                                                                                type: "button",
                                                                                onClick: ($event) => (removeBulkInput(index)),
                                                                                class: "btn-delete-express",
                                                                                title: "Eliminar"
                                                                            }, [
                                                                                _createVNode(_unref(TrashIcon), { size: 16 })
                                                                            ], 8 /* PROPS */, _hoisted_133))
                                                                            : _createCommentVNode("v-if", true)
                                                                    ]));
                                                                }), 128 /* KEYED_FRAGMENT */))
                                                            ]),
                                                            _createElementVNode("button", {
                                                                type: "button",
                                                                onClick: addBulkInput,
                                                                class: "btn-add-bulk-express"
                                                            }, [
                                                                _createVNode(_unref(PlusIcon), { size: 16 }),
                                                                _createTextVNode(" Agregar otro ")
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                                            _createVNode(_unref(InfoIcon), {
                                                                size: 18,
                                                                style: { "color": "#d97706" }
                                                            }),
                                                            _hoisted_135
                                                        ]))
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                onClick: closeRepuestoModal,
                                                class: "btn-cancel-express",
                                                disabled: isSavingRepuesto.value
                                            }, "Cancelar", 8 /* PROPS */, _hoisted_137),
                                            _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn-save-express",
                                                disabled: isSavingRepuesto.value
                                            }, [
                                                (isSavingRepuesto.value)
                                                    ? (_openBlock(), _createBlock(_unref(Loader2Icon), {
                                                        key: 0,
                                                        class: "spin",
                                                        size: 18
                                                    }))
                                                    : _createCommentVNode("v-if", true),
                                                _createElementVNode("span", null, _toDisplayString(isSavingRepuesto.value ? 'Creando...' : 'Crear Repuesto'), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_138)
                                        ])
                                    ], 32 /* NEED_HYDRATION */)
                                ], 2 /* CLASS */)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
